import { useState } from 'react';
import { faqs } from '@/mocks/home';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-5">
            <span className="text-xs font-medium tracking-[0.2em] text-primary-600">信任与答疑</span>
            <h2 className="mt-3 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-4xl">
              关于打不开与换地址
            </h2>
            <p className="mt-4 text-base leading-relaxed text-foreground-600">
              这些是大家问得最多的问题。看完这一节，你就能自己判断问题出在哪、下一步该怎么做。
            </p>

            <div className="mt-8 h-[260px] overflow-hidden rounded-lg md:h-[340px]">
              <img
                src="https://readdy.ai/api/search-image?query=Stack%20of%20warm%20toned%20editorial%20magazines%20on%20a%20cream%20background%2C%20soft%20studio%20light%2C%20minimal%20styling%20with%20terracotta%20and%20olive%20accents%2C%20high%20detail%2C%20no%20text&width=900&height=760&seq=hl-faq-cover&orientation=landscape"
                alt="黑料官网 常见问题 备用地址 指引"
                title="黑料官网怎么进 打不开 FAQ"
                className="h-full w-full object-cover object-top"
              />
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50 px-5 md:px-7">
              {faqs.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <div key={item.q} className="py-5">
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? -1 : index)}
                      className="flex w-full cursor-pointer items-start justify-between gap-4 text-left"
                      aria-expanded={isOpen}
                    >
                      <span className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                        {item.q}
                      </span>
                      <span
                        className={`mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full border transition-colors duration-200 ${
                          isOpen
                            ? 'border-primary-300 bg-primary-500 text-background-50'
                            : 'border-background-300 bg-background-100 text-foreground-700'
                        }`}
                      >
                        <i className={isOpen ? 'ri-subtract-line text-sm' : 'ri-add-line text-sm'}></i>
                      </span>
                    </button>
                    <div
                      className={`grid transition-all duration-300 ease-out ${
                        isOpen ? 'mt-3 grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                      }`}
                    >
                      <p className="overflow-hidden text-sm leading-relaxed text-foreground-600">
                        {item.a}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}